<template>
  <div class="flex flex-col items-center gap-[12px] w-full">
    <div class="pb-[12px] w-full">
      <h2 class="text-[28px] max-md:text-[24px] font-bold text-[#3a3d44] text-center leading-[1.3]">Вход</h2>
    </div>
    <LoginTelegramAuthorize />
    <button
      class="bg-primary/[0.08] rounded-[12px] py-3 w-[368px] max-md:w-full text-primary font-bold text-base"
      @click="$emit('setMode', LoginMode.EMAIL_CHOICE)"
    >
      Через email
    </button>

    <p class="font-normal text-xs text-center text-[rgba(58,61,68,0.6)] pt-[12px] w-[350px] max-md:w-full max-md:px-4">
      Продолжая, вы соглашаетесь с
      <a href="/pdf/oferta.pdf" target="_blank" class="underline !text-[rgba(58,61,68,0.6)] !font-normal"
        >офертой</a
      >
      и даёте
      <a href="/pdf/consent.pdf" target="_blank" class="underline !text-[rgba(58,61,68,0.6)] !font-normal"
        >согласие</a
      >
      на обработку данных в соответствии с
      <a href="/pdf/politic.pdf" target="_blank" class="underline !text-[rgba(58,61,68,0.6)] !font-normal"
        >политикой в отношении обработки персональных данных</a
      >
    </p>
  </div>
</template>

<script setup lang="ts">
import { LoginMode } from '~/interfaces/login/UI';

defineEmits<{
  (e: 'setMode', mode: LoginMode): void;
  (e: 'authorized'): void;
}>();
</script>
